import { Component } from '@angular/core';
import { AnnouncementService } from 'src/app/services/announcement.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.css']
})
export class LearnComponent {
    List: any;
  path: any;

    constructor(private service: AnnouncementService) {}
  
    ngOnInit(): void {
     
     this.path=environment.userApiUrl;
     
     this.service.getLearnPage()
      .subscribe((resp: any) => {
        this.List = resp.data
          .filter((item: any) => item.modelName ==='learn');
      });
  }
  
}
